import React from 'react'

import { ButtonEdit } from '@/components/commons/buttons/ButtonEdit.component'
import { ProfilePageContext } from '../../../../context/profilePage/ProfilePageContext'

import { ButtonComponent } from '@/components/commons/buttons'
import { InputComponent } from '@/components/commons/forms/input/Input.component'
import { Text } from '@/components/commons/typography/Text'
import { cssClass } from '@/shared/utils'
import { UserContext } from 'context'
import { section } from 'styles/v2/pages/profile'
import { helperTextStyle } from './styles/profilePersonalInfo.css'

export const ProfileTitleEdit: React.FC = () => {
  const { profile, ownProfile } = React.useContext(ProfilePageContext)
  const { updateUser } = React.useContext(UserContext)
  const [isEditing, setIsEditing] = React.useState(false)
  const [provisionalTitle, setProvisionalTitle] = React.useState(
    profile?.about || ''
  )
  const [loading, setLoading] = React.useState(false)

  const editable = ownProfile
  const titleMaxLength = 53

  const onCancel = () => {
    setIsEditing(false)
    setProvisionalTitle(profile?.about || '')
  }

  const onSave = async () => {
    setLoading(true)
    await updateUser({
      title: provisionalTitle.slice(0, titleMaxLength),
    })
    setIsEditing(false)
    setLoading(false)
  }

  React.useEffect(() => {
    setProvisionalTitle(profile?.title || '')
  }, [profile?.about, profile?.location, profile?.title])

  return (
    <div className={cssClass([section, 'mt-16'])}>
      <div className="flex justify-space-between items-center">
        <h3 className="text-16 text-primary m-0 mb-12">Title</h3>
        {isEditing && ownProfile ? (
          <span className={cssClass([helperTextStyle, 'mb-12 text-left'])}>
            {titleMaxLength - provisionalTitle.length} characters remaining
          </span>
        ) : (
          <></>
        )}
        {editable && <ButtonEdit onClick={() => setIsEditing((e) => !e)} />}
      </div>
      {isEditing && ownProfile ? (
        <div>
          <InputComponent
            value={provisionalTitle}
            onChange={(e) =>
              setProvisionalTitle(e.target.value.slice(0, titleMaxLength))
            }
            size="small"
          />
        </div>
      ) : (
        <Text color="text-secondary" sizeClass="text-14">
          {profile?.title}
        </Text>
      )}
      {isEditing && ownProfile && (
        <div className="flex mt-12 gap-2">
          <ButtonComponent
            variation="secondary"
            label="Cancel"
            fullWidth
            onClick={onCancel}
            loading={loading}
            size="xSmall"
          />
          <ButtonComponent
            variation="primary"
            label="Save"
            size="xSmall"
            fullWidth
            onClick={onSave}
            loading={loading}
          />
        </div>
      )}
    </div>
  )
}
